export default __webpack_public_path__ + "images/7ad748181de1cadf2e25434581d8af0a.svg";